import React from 'react';
import Header from '../../../../components/layout/headers/Header'
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import EmployeesProfileReportTable from './EmployeesProfileReportTable'

const EmployeesProfileReport = () => {
    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-body">
                <div className="w-full px-4">
                    <EmployeesProfileReportTable  />
                </div>
            </div>
        </>
    );
}

export default EmployeesProfileReport;
